import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../utils/helpers/axiosInstance';

export const fetchProcurementStatus = createAsyncThunk(
  'procurement/fetchStatus',
  async (interactionId, { rejectWithValue }) => {
    try {
            const [totalRes, summaryRes] = await Promise.all([
            axiosInstance.get(`/selected-structures/get-only-raw-material-ids-for-procurement-summary/${interactionId}`),
            axiosInstance.get(`/selected-structures/get-already-added-raw-material-ids-for-procurement-summary/${interactionId}`)
          ]);

     
      
      return {
        interactionId,
        totalRawMaterialList: totalRes.data?.data ?? [],
        summaryRawMaterialList: summaryRes.data?.data ?? []
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch procurement status'
      );
    }
  }
);

export const archiveProcurementData = createAsyncThunk(
  'procurement/archive',
  async (interactionId, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.put(`/procurement/archive/${interactionId}`);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to archive procurement data'
      );
    }
  }
);


